import React from 'react'

import { Flex } from 'antd'
import styled from 'styled-components'

import { Logo, LogoColor } from 'src/components/svgs/Logo'
import { useAuthRedirect } from 'src/hooks/use-auth-redirect'
import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import { LoginTopbar } from 'src/pages/LoginPage/LoginTopbar'

type Props = {
  children?: React.ReactNode
}

const DesktopMain = styled.main`
  flex: 1;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Hero = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  background: #191919;
`

const MobileMain = styled.main`
  flex: 1;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const AppLandingLayout = ({ children }: Props) => {
  useAuthRedirect()
  const { isSmallScreen } = useCurrentBreakpoint()

  if (isSmallScreen()) {
    return (
      <Flex vertical>
        <LoginTopbar />
        <MobileMain>{children}</MobileMain>
      </Flex>
    )
  }

  return (
    <Flex>
      <DesktopMain>{children}</DesktopMain>
      <section className="align-center relative flex h-screen flex-1 justify-center bg-[#191919]">
        <Hero>
          <Flex justify="center" align="center" flex={1}>
            <Logo color={LogoColor.White} width={397} height={163} className="z-1" />
          </Flex>
        </Hero>
      </section>
    </Flex>
  )
}

export default AppLandingLayout
